export const REALTIME = Object.freeze({
    INFO: Object.freeze({
        body: "body",
        icon: "icon",
    }),
    raw: "Raw",
});
